import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

// Company details and links shared with anainfo.com, so the site's footer,
// socials and chat button match the main website.
export const COMPANY = {
  name: 'AnAInfo',
  tagline: 'Improve Wisely',
  phone: '+91 94893 81517',
  phoneHref: 'tel:+919489381517',
  email: 'support@anainfo.com',
  address: 'No:3, V.O.C. 2nd Street, Arulnagar, Madurai 625016',
  whatsapp: 'https://wa.me/919489381517',
};

const COM = 'https://anainfo.com';

export const FOOTER_COLUMNS = [
  {
    title: 'Services',
    links: [
      ['Blockchain Development', '/blockchain-development-company/'],
      ['AI Development', '/ai-development/'],
      ['AI Chatbots', '/ai-chatbot-development/'],
      ['AI Implementation', '/ai-implementation-services/'],
      ['Web Development', '/web-development-company/'],
      ['Mobile App Development', '/mobile-app-development-company/'],
      ['Digital Marketing', '/digital-marketing-company/'],
      ['IT Service Provider', '/it-service-provider/'],
      ['Market Branding', '/market-branding/'],
      ['Hire Developers', '/hire-developers/'],
    ],
  },
  {
    title: 'Blockchain',
    links: [
      ['Crypto Exchange', '/crypto-exchange-development/'],
      ['Clone Scripts', '/crypto-exchange-clone-script/'],
      ['Crypto Wallet', '/crypto-wallet-development/'],
      ['Token Development', '/token-development/'],
      ['NFT Marketplace', '/nft-marketplace-development/'],
      ['DeFi Development', '/defi-development/'],
      ['Smart Contracts', '/smart-contract-development/'],
      ['RWA Tokenisation', '/rwa-tokenization/'],
      ['Crypto Payments & Bots', '/crypto-payment-gateway-development/'],
      ['Web3 Games & Metaverse', '/web3-game-development/'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['About Us', '/about-us/'],
      ['Portfolio', '/portfolio/'],
      ['Career', '/career-opportunities/'],
      ['Internship', '/internships/'],
      ['AnA PowerGen', '/ana-powergen/'],
      ['Builder.ai Recovery', '/builderai-project-recovery/'],
      ['Blog', '/blog/'],
      ['Contact Us', '/contact-anainfo/'],
    ],
  },
  {
    title: 'Where we work',
    links: [
      ['USA', '/usa/'],
      ['Europe & UK', '/europe/'],
      ['UAE & Middle East', '/uae/'],
      ['Privacy Policy', '/privacy-policy/'],
      ['Terms & Conditions', '/terms-and-conditions/'],
    ],
  },
].map(col => ({ ...col, links: col.links.map(([label, path]) => ({ label, href: COM + path })) }));

export const SOCIAL = [
  { label: 'Facebook', href: 'https://www.facebook.com/anainfopvtltd', color: '#1877f2',
    d: 'M13.5 22v-8h2.7l.4-3.2h-3.1V8.8c0-.9.3-1.6 1.6-1.6h1.7V4.4c-.3 0-1.3-.1-2.5-.1-2.5 0-4.1 1.5-4.1 4.2v2.3H7.4V14h2.8v8h3.3z' },
  { label: 'X (Twitter)', href: 'https://x.com/Anainfopvtltd', color: '#000000',
    d: 'M17.8 3h3.1l-6.8 7.8L22 21h-6.2l-4.9-6.4L5.3 21H2.2l7.3-8.3L1.9 3h6.4l4.4 5.8L17.8 3zm-1.1 16.2h1.7L7.4 4.7H5.6l11.1 14.5z' },
  { label: 'WhatsApp', href: COMPANY.whatsapp, color: '#25d366',
    d: 'M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.2-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.7.3-.2.3-.9.9-.9 2.2s.9 2.5 1.1 2.7c.1.2 1.8 2.8 4.4 3.9 1.6.7 2.3.8 3.1.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.1-1.2l-.7-.3z' },
  { label: 'Instagram', href: 'https://www.instagram.com/anainfopvtltd/', color: '#e1306c',
    d: 'M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 8.2a3.2 3.2 0 1 1 0-6.4 3.2 3.2 0 0 1 0 6.4zM17.2 5.6a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4zM12 3.8c2.7 0 3 0 4 .1 2.7.1 4 1.4 4.1 4.1.1 1.1.1 1.4.1 4s0 3-.1 4c-.1 2.7-1.4 4-4.1 4.1-1 .1-1.3.1-4 .1s-3 0-4-.1c-2.7-.1-4-1.4-4.1-4.1-.1-1-.1-1.3-.1-4s0-3 .1-4C4 5.3 5.3 4 8 3.9c1-.1 1.3-.1 4-.1zM12 2c-2.7 0-3.1 0-4.1.1C4.2 2.3 2.3 4.2 2.1 7.9 2 8.9 2 9.3 2 12s0 3.1.1 4.1c.2 3.7 2.1 5.6 5.8 5.8 1 .1 1.4.1 4.1.1s3.1 0 4.1-.1c3.7-.2 5.6-2.1 5.8-5.8.1-1 .1-1.4.1-4.1s0-3.1-.1-4.1c-.2-3.7-2.1-5.6-5.8-5.8C15.1 2 14.7 2 12 2z' },
];

// The anainfo.com logo mark (dark disc with two strokes), drawn in this
// site's blues instead of the orange and yellow used on anainfo.com. On dark
// backgrounds a thin ring keeps the disc visible.
export const LogoMark = ({ size = 40, ring = false }) => (
  <svg width={size} height={size} viewBox="0 0 33 33" fill="none" aria-hidden="true" style={{ flexShrink: 0, display: 'block' }}>
    <circle cx="16.5" cy="16.5" r="16" fill="#14112b" {...(ring ? { stroke: 'rgba(127,176,255,0.45)', strokeWidth: 1 } : {})} />
    <g strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <path d="M11.8071 16.6758L16.0242 23.9801H7.5899L11.8071 16.6758Z" stroke="#7fb0ff" />
      <path d="M23.5414 16.7598L17.4545 6.58594L14.6719 11.8033L20.8334 22.8468H26.1501" stroke="#3d7bff" />
    </g>
  </svg>
);

// AnAInfo logo as on anainfo.com: the mark plus the "AnAInfo / Improve Wisely"
// wordmark, linking home.
export const BrandLogo = ({ light = false, size = 40 }) => (
  <Box component={RouterLink} to="/" aria-label="AnAInfo home" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1.25, textDecoration: 'none' }}>
    <LogoMark size={size} ring={light} />
    <Box sx={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
      <Typography component="span" sx={{ fontWeight: 700, fontSize: size * 0.53, lineHeight: 1, letterSpacing: '-0.01em', color: light ? '#fff' : '#1b1d2b' }}>
        An<Box component="span" sx={{ color: light ? '#7fb0ff' : '#3d7bff' }}>AI</Box>nfo
      </Typography>
      <Typography component="span" sx={{ fontSize: Math.max(10, size * 0.29), mt: 0.4, letterSpacing: '0.02em', color: light ? 'rgba(255,255,255,0.6)' : '#7a7f94' }}>
        {COMPANY.tagline}
      </Typography>
    </Box>
  </Box>
);
